import { Link } from "react-router-dom";

export default function RecruitFooter() {
  return (
    <footer className="bg-acoe-charcoal text-acoe-bg py-16 md:py-24" data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-16">
          <div>
            <Link to="/recruit" className="inline-block">
              <img src="/acoe_logo_white.png" alt="ACOE" className="h-10 w-auto" />
            </Link>
            <p className="text-xs tracking-[0.3em] uppercase opacity-50 mt-2 font-heading">RECRUIT</p>
            <p className="mt-6 text-sm leading-relaxed opacity-70">
              東京発、ファミリーのための<br />ライフスタイル宿泊ブランド
            </p>
          </div>

          <div>
            <p className="text-xs tracking-widest uppercase opacity-50 font-heading mb-4">サイトマップ</p>
            <nav className="flex flex-col gap-2">
              {[
                { label: "トップ", path: "/recruit" },
                { label: "代表メッセージ", path: "/recruit/message" },
                { label: "ACOEについて", path: "/recruit/about" },
                { label: "仕事について", path: "/recruit/work" },
                { label: "制度・環境", path: "/recruit/culture" },
                { label: "募集要項", path: "/recruit/careers" },
                { label: "採用の流れ", path: "/recruit/process" },
                { label: "5分でわかるACOE", path: "/recruit/summary" },
              ].map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-sm opacity-70 hover:opacity-100 transition-opacity"
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>

          <div>
            <p className="text-xs tracking-widest uppercase opacity-50 font-heading mb-4">会社情報</p>
            <div className="text-sm leading-loose opacity-70">
              <p>株式会社セイライグループジャパン</p>
              <p>代表取締役 シリカン アサワ</p>
            </div>
            <div className="mt-6 flex flex-col gap-2">
              <a
                href="https://www.acoe.jp/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm underline underline-offset-4 opacity-70 hover:opacity-100 transition-opacity"
              >
                ACOE 公式サイト
              </a>
              <a
                href="https://acoe-partners.jp/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm underline underline-offset-4 opacity-70 hover:opacity-100 transition-opacity"
              >
                パートナーサイト
              </a>
              <a
                href="https://www.instagram.com/acoe.tokyo/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm underline underline-offset-4 opacity-70 hover:opacity-100 transition-opacity"
              >
                Instagram
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <p className="text-xs opacity-40">&copy; {new Date().getFullYear()} SEIRAI GROUP JAPAN. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <Link to="/recruit/privacy" className="text-xs opacity-40 hover:opacity-70 transition-opacity">
              プライバシーポリシー
            </Link>
            <Link to="/recruit/contact" className="text-xs opacity-40 hover:opacity-70 transition-opacity">
              採用について問い合わせる
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
